import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { WorkOrderSearchCommand } from '../../models/order/work-order';

export interface WorkOrderDispatchReportResult {
  blob: Blob;
  workOrderCount: number;
}

@Injectable({
  providedIn: 'root',
})
export class CustomerOrderDispatchReportProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/report';

  private getLocalOffsetMinutes(): number {
    return -new Date().getTimezoneOffset();
  }

  public generateWorkOrderDispatchReport(filters: WorkOrderSearchCommand, detailed: boolean): Observable<WorkOrderDispatchReportResult> {
    const body = {
      ...filters,
      createdFrom: filters.createdFrom ? filters.createdFrom.toISOString() : undefined,
      createdTo: filters.createdTo ? filters.createdTo.toISOString() : undefined,
    };

    const params = new HttpParams().set('detailed', detailed.toString()).set('timezoneOffset', this.getLocalOffsetMinutes().toString());

    return this.httpClient
      .post(`${this.baseUrl}/work-order-dispatch`, body, {
        params,
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        map((response: HttpResponse<Blob>) => {
          const workOrderCount = Number(response.headers.get('X-Work-Order-Count') ?? NaN);
          return {
            blob: response.body!,
            workOrderCount: Number.isNaN(workOrderCount) ? response.body!.size : workOrderCount,
          };
        }),
      );
  }
}
